import api from './api';

export interface Comment {
  id: string;
  userId: string;
  devotionalId: string;
  content: string;
  status: 'pending' | 'approved' | 'rejected';
  createdAt: string;
  updatedAt: string;
  user?: {
    id: string;
    name: string;
    email: string;
  };
  devotional?: {
    id: string;
    title: string;
  };
}

export interface CommentStats {
  total: number;
  pending: number;
  approved: number;
  rejected: number;
}

const commentsService = {
  getPending: async (): Promise<Comment[]> => {
    const response = await api.get('/comments/pending');
    return response.data;
  },

  getAll: async (): Promise<Comment[]> => {
    const response = await api.get('/comments/all');
    return response.data;
  },

  getStats: async (): Promise<CommentStats> => {
    const response = await api.get('/comments/stats');
    return response.data;
  },

  approve: async (id: string): Promise<Comment> => {
    const response = await api.patch(`/comments/${id}/approve`);
    return response.data;
  },

  reject: async (id: string): Promise<Comment> => {
    const response = await api.patch(`/comments/${id}/reject`);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/comments/${id}`);
  },
};

export default commentsService;
